import React from 'react';

export const DiamondSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 35 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.7137 26.3962L1.62272 10.3481C0.679179 9.27351 0.62529 7.68231 1.49397 6.54635L5.59944 1.17765C6.16705 0.435393 7.04811 0 7.98252 0H27.9455C28.9203 0 29.8343 0.473595 30.3964 1.26995L34.1555 6.59533C34.9465 7.71583 34.8768 9.23003 33.9863 10.2732L20.2497 26.3646C19.0631 27.7547 16.9197 27.7696 15.7137 26.3962Z" fill={color} />
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 0H7L0 9H10L13 0Z" fill="#BDDDF4" />
      <path d="M36 9L29 0H23L26 9H36Z" fill="#5DADEC" />
      <path d="M26 9H36L18 30L26 9Z" fill="#4289C1" />
      <path d="M10 9H0L18 30L10 9ZM13 0L10 9H26L23 0H13Z" fill="#8CCAF7" />
      <path d="M18 30L10 9H26L18 30Z" fill="#5DADEC" />
    </svg>
  )
}